import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SearchComponent = ({ onSearch, onFocusChange }) => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation(); // Hook to get current location

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  const handleFocus = () => {
    onFocusChange(true);
    // Navigate to the search page
    navigate("/search");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query) {
      // Hide keyboard by blurring the active element
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      // Navigate to /search with the query parameter
      navigate(`/search?query=${query}`);
    }
  };

  // Clear query when location (pageName) changes
  useEffect(() => {
    setQuery(""); // Clear the query
  }, [location]); // This will run whenever the location changes (i.e., pageName changes)

  return (
    <div className="search-container">
      <form id="searchForm" method="get" onSubmit={handleSubmit}>
        <input
          autoComplete="off"
          className="search expandright"
          id="searchright"
          type="search"
          name="q"
          value={query}
          placeholder="Search"
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={() => setTimeout(() => onFocusChange(false), 200)} // Delay to allow dropdown interaction
        />
        <label className="button searchbutton" htmlFor="searchright">
          <span className="mglass">&#9906;</span>
        </label>
      </form>
    </div>
  );
};

export default SearchComponent;
